import { render, staticRenderFns } from "./dialogEditorganizastion.vue?vue&type=template&id=79956d72&lang=html"
import script from "./dialogEditorganizastion.vue?vue&type=script&lang=js"
export * from "./dialogEditorganizastion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports